import Button from "@shared/ui/Button";
import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import Headline, { HEADLINE_SIZES } from "@shared/ui/Headline";
import Label, { LABEL_SIZES } from "@shared/ui/Label";
import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const { messages } = useIntl();
  const navigate = useNavigate();
  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center gap-y-lg">
      <Label size={LABEL_SIZES.MEDIUM} color="text-secondary">
        404
      </Label>
      <Headline size={HEADLINE_SIZES.X_LARGE}>
        {messages["common"]["404"]["title"]}
      </Headline>
      <BodyText
        size={BODY_TEXT_SIZES.MEDIUM}
        style={{ maxWidth: "382px" }}
        className="text-center"
        color="text-secondary"
      >
        {messages["common"]["404"]["desc1"]}
        <a
          href="mailto:support@makula.io"
          className="underline underline-offset-2 hover:cursor-pointer"
        >
          {messages["common"]["404"]["desc2"]}
        </a>
        {messages["common"]["404"]["desc3"]}
      </BodyText>
      <Button
        text={messages["common"]["404"]["goBack"]}
        onClick={() => navigate("/app/work")}
      />
    </div>
  );
};

export default NotFoundPage;
